import React, { Component } from "react";
import { Row, Col, Card, CardBody, Badge } from "reactstrap";
import Moment from "react-moment";
import { Redirect } from '../../utils/router-compat';
import _ from "lodash";
import OfftakeEntryService from "../../services/OfftakeEntryService";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";

class OfftakeEntriesVerificationStatusFM extends Component {
  state = {
    offtakeEntries: [],
    offtakeEntriesCloned: [],
    offtakeEntriesCount: [],
    redirectToEditOfftakeEntry: false,
    uuid: "",
    clickedStatus: "all",
    isLoading: false,
    memberId: null
  };

  componentWillMount() {
    // this.getOfftakeEntries(false);
    // this.getOfftakeEntriesCount();
  }

  componentDidMount() {
    const searchParam = this.props.location.search;
    let memberUuid = null;
    if (searchParam) {
      const keys = searchParam.split("&");
      const idString = keys[0];
      // const nameString = keys[1];
      const id = idString.split("=");
      memberUuid = id[1];
      this.setState({ memberId: memberUuid });

      if (memberUuid) {
        this.loadInitialData(memberUuid);
      } else {
        this.loadInitialData();
      }
    } else {
      this.loadInitialData();
    }
  }

  loadInitialData = uuid => {
    this.getOfftakeEntries(false, uuid);
    this.getOfftakeEntriesCount(uuid);
  };

  downloadReport = () => {
    this.getOfftakeEntries(true);
  };

  getOfftakeEntries = async (downloadReport, uuid) => {
    let { offtakeEntries, offtakeEntriesCloned, isLoading } = this.state;
    try {
      // if (!downloadReport) {
      isLoading = true;
      this.setState({ isLoading });
      // }
      const { data } = await OfftakeEntryService.getOfftakeEntries(
        downloadReport,
        uuid
      );
      isLoading = false;
      this.setState({ isLoading });
      if (data && !downloadReport) {
        offtakeEntries = data.data;
        offtakeEntriesCloned = _.cloneDeep(data.data);
      } else if (data.data && data.data.file) {
        const link = document.createElement("a");
        link.href = data.data.file;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      this.setState({ offtakeEntries, offtakeEntriesCloned });
    } catch (error) {
      console.log(error);
      this.setState({ isLoading: false });
    }
  };

  getOfftakeEntriesCount = async uuid => {
    let { offtakeEntriesCount } = this.state;
    try {
      const { data } = await OfftakeEntryService.getOfftakeEntriesCount(uuid);
      if (data) {
        offtakeEntriesCount = data.data;
        offtakeEntriesCount = _.sortBy(offtakeEntriesCount, "status");
      }
      this.setState({ offtakeEntriesCount });
    } catch (error) {
      console.log(error);
    }
  };

  onInvoiceClick = uuid => {
    let { redirectToEditOfftakeEntry } = this.state;
    redirectToEditOfftakeEntry = true;
    this.setState({ redirectToEditOfftakeEntry, uuid: window.btoa(uuid) });
  };

  onClickStatus = (status = "") => {
    let { clickedStatus, offtakeEntries, offtakeEntriesCloned } = this.state;
    clickedStatus = status;

    if (clickedStatus.toLowerCase() === "all") {
      offtakeEntries = offtakeEntriesCloned;
      this.setState({ clickedStatus, offtakeEntries });
      return;
    }

    offtakeEntries = _.filter(offtakeEntriesCloned, item => {
      if ((status || "").toLowerCase() === "pending") {
        return (
          (item.status || "").toLowerCase() === status.toLowerCase() ||
          (item.status || "").toLowerCase() === "pending_zfm"
        );
      }
      return (item.status || "").toLowerCase() === status.toLowerCase();
    });

    this.setState({ clickedStatus, offtakeEntries });
  };

  sortData = (columnName, sort) => {
    let { offtakeEntries } = this.state;
    if (sort === "asc") {
      if (columnName === "purchase_date" || columnName === "created_at") {
        offtakeEntries = offtakeEntries.sort((a, b) => {
          return new Date(a[columnName]) - new Date(b[columnName]);
        });
      } else {
        offtakeEntries = offtakeEntries.sort((a, b) => {
          return new a[columnName]() - b[columnName];
        });
      }
    } else if (columnName === "purchase_date" || columnName === "created_at") {
      offtakeEntries = offtakeEntries.sort((a, b) => {
        return new Date(b[columnName]) - new Date(a[columnName]);
      });
    } else {
      offtakeEntries = offtakeEntries.sort((a, b) => {
        return new b[columnName]() - a[columnName];
      });
    }

    this.setState({ offtakeEntries });
  };

  render() {
    const {
      isLoading,
      offtakeEntriesCount,
      offtakeEntries,
      offtakeEntriesCloned,
      redirectToEditOfftakeEntry,
      uuid,
      clickedStatus
    } = this.state;
    return (
      <div>
        {isLoading && <CustomSpinner />}
        {
          <>
            {redirectToEditOfftakeEntry && (
              <Redirect
                to={{ pathname: "/editOfftakeEntry", search: `q=${uuid}` }}
              />
            )}
            <Row>
              <Col>
                <span className="offtake-title">
                  Offtake Entries Verification Status
                </span>
              </Col>
            </Row>

            {offtakeEntriesCloned && offtakeEntriesCloned.length > 0 && (
              <Row style={{ marginTop: "15px" }}>
                <Col>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col style={{ display: "flex" }}>
                          {(offtakeEntriesCount || []).map(item => {
                            return (
                              <div
                                key={item.status}
                                onClick={e => this.onClickStatus(item.status)}
                                className={
                                  item.status === clickedStatus
                                    ? "offtake-status-div-active"
                                    : "offtake-status-div"
                                }
                                style={{ marginLeft: "10px", display: "flex" }}
                              >
                                {(item.status || "").toLowerCase() ===
                                  "all" && (
                                    <span
                                      className="offtake-count-status"
                                      style={{ color: "#6e777f" }}
                                    >
                                      {item.count}
                                    </span>
                                  )}
                                {(item.status || "").toLowerCase() ===
                                  "pending" && (
                                    <span
                                      className="offtake-count-status"
                                      style={{ color: "#e47927" }}
                                    >
                                      {item.count}
                                    </span>
                                  )}

                                {(item.status || "").toLowerCase() ===
                                  "rejected" && (
                                    <span
                                      className="offtake-count-status"
                                      style={{ color: "#e66c6c" }}
                                    >
                                      {item.count}
                                    </span>
                                  )}

                                {(item.status || "").toLowerCase() ===
                                  "approved" && (
                                    <span
                                      className="offtake-count-status"
                                      style={{ color: "#51b856" }}
                                    >
                                      {item.count}
                                    </span>
                                  )}
                                <div className="offtake-text-status">
                                  {item.status}
                                </div>
                              </div>
                            );
                          })}
                        </Col>
                        <Col>
                          <div
                            className="d-flex-row Download-report-wrapp pull-right"
                            style={{ cursor: "pointer" }}
                          >
                            <img src="images/group-6.svg" alt="" />
                            &nbsp;
                            <span
                              className="Download-Full-Report"
                              onClick={this.downloadReport}
                            >
                              Download Full Report
                            </span>
                          </div>
                        </Col>
                      </Row>

                      <Row style={{ marginTop: "15px" }}>
                        <Col>
                          <table className="table table-bordered table-responsive">
                            <thead
                              id="wc-table-head"
                              className="offtake-check-table-head"
                            >
                              <tr>
                                <th>Submitted Date</th>
                                <th>Purchased Date</th>
                                <th>Invoice Number</th>
                                <th>Invoice in favour of</th>
                                <th>Dealer Name</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody id="wc-table-body">
                              {(offtakeEntries || []).map((item, i) => {
                                return (
                                  <tr key={i}>
                                    <td>
                                      <Moment format="DD MMM YYYY">
                                        {item.created_at}
                                      </Moment>
                                    </td>
                                    <td>
                                      <Moment format="DD MMM YYYY">
                                        {item.purchase_date}
                                      </Moment>
                                    </td>
                                    <td>
                                      <span
                                        onClick={e =>
                                          this.onInvoiceClick(item.uuid)
                                        }
                                        className="Download-Full-Report"
                                        style={{
                                          fontSize: "12px",
                                          cursor: "pointer"
                                        }}
                                      >
                                        {item.invoice_number}
                                      </span>
                                    </td>
                                    <td style={{ fontWeight: "normal" }}>
                                      {item.subsidiary_name}
                                    </td>
                                    <td style={{ fontWeight: "normal" }}>
                                      {item.dealer_name}
                                    </td>
                                    <td style={{ width: "200px" }}>
                                      {(item.status || "").toLowerCase() ===
                                        "pending" && (
                                          <Badge
                                            color="primary"
                                            className="offtake-status-table"
                                            style={{
                                              backgroundColor:
                                                "rgb(228, 121, 39) !important"
                                            }}
                                          >
                                            {item.status}
                                          </Badge>
                                        )}
                                      {(item.status || "").toLowerCase() ===
                                        "pending_zfm" && (
                                          <Badge
                                            color="primary"
                                            className="offtake-status-table-zfm"
                                            style={{
                                              backgroundColor:
                                                "rgb(228, 121, 39) !important"
                                            }}
                                          >
                                            Pending ZFM
                                          </Badge>
                                        )}
                                      {(item.status || "").toLowerCase() ===
                                        "approved" && (
                                          <Badge
                                            color="success"
                                            className="offtake-status-table"
                                            style={{
                                              backgroundColor:
                                                "#51b856 !important"
                                            }}
                                          >
                                            {item.status}
                                          </Badge>
                                        )}
                                      {(item.status || "").toLowerCase() ===
                                        "rejected" && (
                                          <Badge
                                            color="danger"
                                            className="offtake-status-table"
                                            style={{
                                              backgroundColor:
                                                "#e66c6c !important"
                                            }}
                                          >
                                            {item.status}
                                          </Badge>
                                        )}
                                      &nbsp;
                                      <span
                                        title={item.remark}
                                        className="incorrect-entries-label text-overflow-dots"
                                      >
                                        {item.remark}
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })}

                              {offtakeEntries && offtakeEntries.length === 0 && (
                                <tr>
                                  <td
                                    colSpan="6"
                                    style={{ fontSize: "18px", color: "grey" }}
                                  >
                                    <center>No match found</center>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}

            {offtakeEntriesCloned && offtakeEntriesCloned.length === 0 && (
              <Row style={{ marginTop: "15px" }}>
                <Col>
                  <Card>
                    <CardBody style={{ fontSize: "18px", color: "grey" }}>
                      <center>No records found</center>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </>
        }
      </div>
    );
  }
}

export default OfftakeEntriesVerificationStatusFM;
